export const REPORT_TYPES = {
  PER_FILTERS: 'per-filters',
  FSMA: 'fsma',
  EUDR: 'eudr',
} as const;

export type ReportType = (typeof REPORT_TYPES)[keyof typeof REPORT_TYPES];

export const REPORT_FILE_TYPES = {
  PDF: 'pdf',
  CSV: 'csv',
  EXCEL: 'excel',
} as const;

export type ReportFileType =
  (typeof REPORT_FILE_TYPES)[keyof typeof REPORT_FILE_TYPES];

export const REPORT_FIELD_NAMES = {
  REPORT_TYPE: 'reportType',
  FILE_TYPE: 'fileType',
  INCLUDED_COLUMNS: 'includedColumns',
  TRACEABILITY_ID: 'traceabilityId',
  LOT_CODE: 'lotCode',
  REFERENCE_DOCUMENT: 'referenceDocument',
} as const;

export const REPORT_COLUMN_KEYS = {
  TRACEABILITY_ID: 'traceabilityId',
  TRANSACTION_DATE: 'transactionDate',
  EVENT: 'event',
  PRODUCT: 'product',
  COMMODITY: 'commodity',
  VARIETY: 'variety',
  EVENT_DATE: 'eventDate',
  QUANTITY: 'quantity',
  UNIT_OF_MEASURE: 'unitOfMeasure',
  BALANCE: 'balance',
  LOCATION: 'location',
  REFERENCE_DOCUMENT_TYPE: 'referenceDocumentType',
  REFERENCE_DOCUMENT_NUMBER: 'referenceDocumentNumber',
  DESTINATION: 'destination',
  TRACEABILITY_LOT_CODE: 'traceabilityLotCode',
  TRACEABILITY_LOT_CODE_LOCATION: 'traceabilityLotCodeLocation',
  ORIGIN_LOCATION: 'originLocation',
  ACTIONS: 'actions',
} as const;
